<div mat-dialog-title>Rebalance types
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
</div>
<mat-dialog-content class="rebalances-types-info-dialog">
  <div class="block">
    The rebalance type determines the type of rebalancing actions that will occur in this rebalance. Select a rebalance type to learn more about its settings.
  </div>

  <div class="rebalances-types-info-accordion">
    <mat-accordion [multi]="true">

      <mat-expansion-panel id="fullRebalance_info_panel" [expanded]="expandedPanelId === 'FULL_REBALANCE'">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Full rebalance
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div id="fullRebalance_info">
            <strong>Potential buys and/or sells may be identified in order to do any or all of the following:</strong> <br>
            <strong>- GENERATE cash</strong> if an account's cash is below its cash minimum and set-aside cash values - or if extra cash is desired or an account is being liquidated. <br>
            <strong>- INVEST cash </strong> if an account's cash is above its cash max and set-aside cash values. <br>
            <strong>- REBALANCE security positions</strong> that are below the minimum % band or above the maximum % band of the portfolio's assigned model targets. <br>

            <div style="padding-top:8px;"><strong>Optional:</strong> Specify the accounts in which to generate extra cash for withdrawal.</div>
          </div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="generalAndOrInvestCash_info_panel" [expanded]="expandedPanelId === 'GENERATE_INVEST'">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Generate and/or invest cash
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div id="generalAndOrInvestCash_info">
            <strong>Potential buys and/or sells may be identified in order to do either or both of the following:</strong> <br>
            <strong>- INVEST cash</strong> if an account's cash is above its cash target and set-aside cash values.<br>
            <strong>- GENERATE cash</strong> if an account's cash is below its cash minimum and set-aside cash values - or if extra cash is desired or an account is being liquidated (see below).
            <div style="padding-top:8px;"><strong>Optional:</strong> Specify the accounts in which to generate extra cash or liquidate.</div>
          </div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="generalCash_info_panel" [expanded]="expandedPanelId === 'GENERATE_CASH'">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Generate cash only
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div id="generalCash_info">Potential <strong>Sells</strong> may be identified in order to generate cash if an account's cash is below its
          cash minimum and set-aside cash values - or if extra cash is desired or an account is being liquidated.
        </div>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel id="investCashOnly_info_panel" [expanded]="expandedPanelId === 'INVEST_CASH'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Invest cash only
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div id="investCashOnly_info">Potential <strong>Buys</strong> may be identified in order to invest cash if an account's cash is above its cash target and set-aside cash values.
      </div>
    </ng-template>
  </mat-expansion-panel>

  <mat-expansion-panel id="adjustSecurities_info_panel" [expanded]="expandedPanelId === 'ADJUST_SECURITIES'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Adjust securities
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div id="adjustSecurities_info">Potential <strong>buys and/or sells</strong> may be identified to adjust a position of a security to the target specified.
    </div>
  </ng-template>
</mat-expansion-panel>

<mat-expansion-panel id="harvestTaxLosses_info_panel" [expanded]="expandedPanelId === 'HARVEST_TAX_LOSS'">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Tax Loss Harvest
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <div id="harvestTaxLosses_info">
      <strong>Potential buys and sells may be identified in order to:</strong><br>
      <strong>- REALIZE losses</strong> in specified securities that have losses greater than the minimum specified amounts.<br>
      <strong>- INVEST the generated cash</strong> into the replacement securities specified.
    </div>
  </ng-template>
</mat-expansion-panel>

@if (showTLH_FULL && ENABLE_TLH_FR) {
  <mat-expansion-panel id="harvestTaxLossesFullRebal_info_panel" [expanded]="expandedPanelId === 'TLH_FULL_REBALANCE'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Tax Loss Harvest + Full Rebalance
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div id="harvestTaxLossesFullRebal_info">
        <strong>Potential buys and/or sells may be identified in order to do any or all of the following:</strong> <br>
        <strong>- REALIZE losses</strong> in specified securities that have losses greater than the minimum specified amounts and add the proceeds to account cash.<br>
        <strong>- GENERATE cash</strong> if an account's cash is below its cash minimum and set-aside cash values - or if extra cash is desired or an account is being liquidated. <br>
        <strong>- INVEST cash </strong> if an account's cash is above its cash max and set-aside cash values. <br>
        <strong>- REBALANCE security positions</strong> that are below the minimum % band or above the maximum % band of the portfolio's assigned model targets. <br>
        <div style="padding-top:8px;"><strong>Optional:</strong>  Specify the accounts in which to generate extra cash for withdrawal.</div>
      </div>
    </ng-template>
  </mat-expansion-panel>
}

<mat-expansion-panel id="replaceSecurities_info_panel" [expanded]="expandedPanelId === 'REPLACE_SECURITIES'">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Replace securities
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <div id="replaceSecurities_info">
      <strong>Potential buys and sells may be identified in order to:</strong><br>
      <strong>- SELL securities</strong> that have been specified. <br>
      <strong>- INVEST the generated cash</strong> into replacement securities specified.
      <br>
      </div>
    </ng-template>
  </mat-expansion-panel>

  <mat-expansion-panel id="manualAdjustment_info_panel" [expanded]="expandedPanelId === 'MANUAL_ADJUSTMENT'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Manual adjustment
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div id="manualAdjustment_info">Use a manual adjustment to edit the portfolio analysis and create the buys or sells you want.</div>
    </ng-template>
  </mat-expansion-panel>

  <mat-expansion-panel id="coveredCall_info_panel" [expanded]="expandedPanelId === 'COVERED_CALL'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Covered call
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div id="coveredCall_info">Potential <strong>BUYS and SELLS</strong> may be identified in order to: <br>
      <strong>- SELL to open</strong> call options on underlying securities that have been specified. <br>
      <strong>- BUY to cover</strong> call options on underlying securities that have been specified. <br>
      Simultaneously <strong>BUY</strong> underlying equity and <strong>SELL to open</strong> call options on the securities that have been specified.
    </div>
  </ng-template>
</mat-expansion-panel>

</mat-accordion>
</div>
</mat-dialog-content>
<mat-dialog-actions  >
  <button (click)="close()" class="btn-medium-primary">Close</button>
</mat-dialog-actions>



